import React, { useState } from 'react';
import { FieldProps, FieldValidation } from '@rjsf/core';
import { FormControl, TextField } from '@material-ui/core';

type repoFieldType = {
  repoName: string;
  newRepoUrl: string;
  repoOwner: string;
  repoOrg: string;
};

export const NewRepoOnly = ({ onChange, formContext }: FieldProps<string>) => {
  const [formState, setFormState] = useState<repoFieldType>({
    repoName: '',
    newRepoUrl: '',
    repoOwner: '',
    repoOrg: '',
  });

  const repoUrl: string = formContext.formData.repoUrl || '';

  const repoUrlPrefix: string = `${repoUrl.slice(0, 13)}?`;

  const params: URLSearchParams = new URLSearchParams(repoUrl.slice(14));

  const owner: string = `project=${params.get('owner')}&`;
  const org: string = `organization=${params.get('organization')}`;

  onChange(formState);

  return (
    <FormControl margin="normal">
      <TextField
        id="repoName"
        label="Repository Name"
        variant="standard"
        onChange={e => {
          setFormState({
            repoName: e.target.value.toString(),
            newRepoUrl: `${repoUrlPrefix}${owner}repo=${e.target.value.toString()}&${org}`,
            repoOwner: `${params.get('owner')}`,
            repoOrg: `${params.get('organization')}`,
          });
        }}
        value={formState.repoName}
        helperText="Enter the name for the repo."
      />
    </FormControl>
  );
};

export const newRepoOnlyValidation = (
  value: repoFieldType,
  validation: FieldValidation,
) => {
  if (value.repoName === undefined || value.repoName.length < 1) {
    validation.addError('Please enter a repository name.');
  }

  /** Regex allows any combination of letters, lowercase or uppercase, numbers and special chars \
  Regex excludes any whitespaces */
  const targetPathRegex = /^[\w-]+$/;

  if (!targetPathRegex.test(value.repoName)) {
    validation.addError(
      'Repository name can not have whitespaces may only include upper and lowercase letters, numbers and the special char -',
    );
  }
};
